import { useLang } from "@/context/LanguageContext";
import { contacts } from "@/data/content";
import { Reveal } from "@/components/Reveal";
import { MapPin, ArrowRight } from "@phosphor-icons/react";

export const StoreMap = () => {
  const { t } = useLang();
  const { mapLat, mapLon, address } = contacts;
  const d = 0.02;
  const bbox = `${mapLon - d}%2C${mapLat - d}%2C${mapLon + d}%2C${mapLat + d}`;
  const embed = `https://www.openstreetmap.org/export/embed.html?bbox=${bbox}&layer=mapnik&marker=${mapLat}%2C${mapLon}`;
  const directions = `https://www.google.com/maps/search/?api=1&query=${mapLat}%2C${mapLon}`;

  return (
    <section data-testid="map" className="relative bg-[#FAFAF7] py-24 md:py-36">
      <div className="max-w-[1400px] mx-auto px-6 md:px-12">
        <div className="grid lg:grid-cols-[1fr_1.4fr] gap-12 lg:gap-16 items-center">
          <div>
            <Reveal>
              <p className="text-sm tracking-luxe uppercase text-[#A39B8E] mb-6">{t.map.kicker}</p>
            </Reveal>
            <Reveal delay={0.05}>
              <h2 className="font-display font-light text-4xl sm:text-5xl lg:text-6xl leading-[1.02] tracking-tight">
                {t.map.title}
              </h2>
            </Reveal>
            <Reveal delay={0.1}>
              <p className="mt-6 text-[#1A1A1A]/60 max-w-md leading-relaxed">{t.map.subtitle}</p>
            </Reveal>

            <Reveal delay={0.15}>
              <div className="mt-8 flex items-start gap-3 border-t border-black/10 pt-6 max-w-md">
                <MapPin size={22} weight="thin" className="text-[#8B7355] shrink-0 mt-1" />
                <div>
                  <p className="text-xs tracking-luxe uppercase text-[#A39B8E]">{t.map.addressLabel}</p>
                  <p className="mt-1 text-lg font-display font-light text-[#1A1A1A]">Milano</p>
                  <p className="text-[#1A1A1A]/70">{address}</p>
                </div>
              </div>
            </Reveal>

            <Reveal delay={0.2}>
              <a
                data-testid="map-directions"
                href={directions}
                target="_blank"
                rel="noopener noreferrer"
                className="group mt-8 inline-flex items-center gap-2 border border-[#1A1A1A] text-[#1A1A1A] px-7 py-3.5 text-sm hover:bg-[#1A1A1A] hover:text-white transition-colors duration-300"
              >
                {t.map.cta}
                <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
              </a>
            </Reveal>
          </div>

          <Reveal delay={0.1} className="h-[380px] md:h-[520px] overflow-hidden border border-black/10">
            <iframe
              title="Zen Home Milano — Lacchiarella"
              className="w-full h-full grayscale contrast-[1.05]"
              loading="lazy"
              src={embed}
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
};
